import React from 'react';
import './Certificates.css';
import Navbar from './Navbar';
import { FaCertificate, FaGlobe, FaCode, FaLaptopCode, FaDatabase } from 'react-icons/fa';
import { RiBook2Line, RiTestTubeLine } from 'react-icons/ri';

function Certificates() {
    const certificates = [
        {
          title: "Responsive Web Design",
          provider: "FreeCodeCamp",
          link: "https://www.freecodecamp.org/certification/Bollamshiva/responsive-web-design",
          icon: <FaCertificate />,
        },
        {
          title: "Data Science Fundamentals",
          provider: "Cognitive Class",
          link: "https://courses.cognitiveclass.ai/certificates/0d12197a6b964e4294c2d4143ebbaad6",
          icon: <FaGlobe />,
        },
        {
          title: "Machine Learning Foundations",
          provider: "Cognitive Class",
          link: "https://courses.cognitiveclass.ai/certificates/a769487437654a849e432701a84e6ae7",
          icon: <FaCode />,
        },
        {
          title: "Full Stack Developer Nanodegree",
          provider: "Udacity",
          link: "https://graduation.udacity.com/confirm/GLY2CE4M",
          icon: <FaLaptopCode />,
        },
        {
          title: "Blockchain A-Z Learn How to build your first Blockchain",
          provider: "Udemy",
          link: "https://drive.google.com/file/d/1DFxMhUhJbSXovGQOYW3cpa147iIn1Bj1/view?usp=sharing",
          icon: <RiBook2Line />,
        },
        {
          title: "Hackerrank Java Basic Test",
          provider: "Hackerrank",
          link: "https://drive.google.com/file/d/1bd638ZTi96HbcibCFq94QNQqpRufKY5R/view?usp=sharing",
          icon: <RiTestTubeLine />,
        },
        {
          title: "Hackerrank Python Test",
          provider: "Hackerrank",
          link: "https://drive.google.com/file/d/1xW3Yrkum_AVvlvQpHSfndfGCDE9o_UVs/view?usp=sharing",
          icon: <RiTestTubeLine />,
        },
        {
          title: "Hackerrank Problem Solving Basic",
          provider: "Hackerrank",
          link: "https://drive.google.com/file/d/1FLc_CiSEwBHFgAoGEiAzLhfGVSvH9AqY/view?usp=sharing",
          icon: <RiTestTubeLine />,
        },
        {
          title: "SQL for Beginners",
          provider: "Udemy",
          link: "https://drive.google.com/file/d/13gZ1wHEw27jabjpxwvDkZwmV0r9hIfFu/view?usp=sharing",
          icon: <FaDatabase />,
        },
        {
          title: "Python and Django for Beginners",
          provider: "Udemy",
          link: "https://www.udemy.com/certificate/UC-8d4ccf01-df99-4ba2-8c47-17f6cb21c784/",
          icon: <FaCode />,
        },
      ];
      

  return (
    <div>
      <Navbar />
      <div className="certificates-container">
        {certificates.map((certificate, index) => (
          <div className="certificate-item" key={index}>
            <div className="certificate-icon">{certificate.icon}</div>
            <div className="certificate-details">
              <h2>{certificate.title}</h2>
              <p>{certificate.provider}</p>
              <a href={certificate.link} target="_blank" rel="noopener noreferrer">View Certificate</a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Certificates;
